import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ReactFlowProvider } from '@xyflow/react';

// ThemeProvider를 import 합니다.
import { ThemeProvider } from './context/ThemeContext';

import MindmapPage from './pages/MindmapPage';
import DetailPage from './pages/DetailPage';
import SearchResultsPage from './pages/SearchResultsPage';
import ContentDetailPage from './pages/NewsDetailPage';


function App() {
  return (
    // 이 부분이 가장 중요합니다. ThemeProvider로 전체를 감싸주세요.
    <ThemeProvider>
      <ReactFlowProvider>
        <Routes>
          <Route path="/" element={<MindmapPage />} />
          <Route path="/details/:serviceId" element={<DetailPage />} />
          <Route path="/search" element={<SearchResultsPage />} />
          <Route path="/content/:contentId" element={<ContentDetailPage />} />
        </Routes>
      </ReactFlowProvider>
    </ThemeProvider>
  );
}

export default App;